import { createContext } from "react"
import { initialInspectionProgressState } from "./reducer"
import { InspectionProgressAction, InspectionProgressState } from "./types"

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const InspectionProgressContext = createContext<[InspectionProgressState, React.Dispatch<InspectionProgressAction>]>([initialInspectionProgressState, () => {}])
